import { useTranslation } from "react-i18next";
import { EncryptedText } from "@/components/ui/encrypted-text";

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-black flex items-center justify-center p-4">
      <div className="flex flex-col gap-8 items-center justify-center max-w-2xl text-center">
        <div className="flex flex-col gap-4">
          <EncryptedText
            text={t("errors.notFound.title")}
            encryptedClassName="text-neutral-400 dark:text-neutral-600 text-8xl md:text-9xl font-bold"
            revealedClassName="text-gray-900 dark:text-white text-8xl md:text-9xl font-bold"
            revealDelayMs={30}
          />
          <EncryptedText
            text={t("errors.notFound.heading")}
            encryptedClassName="text-neutral-500 text-3xl md:text-4xl font-semibold"
            revealedClassName="text-gray-800 dark:text-gray-200 text-3xl md:text-4xl font-semibold"
            revealDelayMs={40}
          />
        </div>

        <EncryptedText
          text={t("errors.notFound.description")}
          encryptedClassName="text-neutral-500 text-lg md:text-xl"
          revealedClassName="text-gray-600 dark:text-gray-400 text-lg md:text-xl"
          revealDelayMs={50}
        />
      </div>
    </div>
  );
}
